import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import FullPageDialog from '../components/FullPageDialog/FullPageDialog';
import { StudentCourseTotalContent } from './components/StudentCourseTotalContent/StudentCourseTotalContent';
import StudentCourseTotalWidget from './components/StudentCourseTotalWidget/StudentCourseTotalWidget';
import { useStudentCourseTotal } from './hooks/useStudentCourseTotal';
import {
  DisableEscapeKeyDownProvider,
  useDisableEscapeKeyDown,
} from '../hooks/useDisableEscapeKeyDown';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
    },
  },
});

function StudentCourseTotal({ courseId, apiHost, handleISGLaunch }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { disableEscapeKeyDown } = useDisableEscapeKeyDown();

  const { data, isLoading, error } = useStudentCourseTotal(apiHost, courseId);

  if (isLoading || error || !data) {
    return null;
  }

  const {
    courseStudentTotals = [],
    lowScoringStudentCount = 0,
    currentWeekDate = null,
    previousWeekDate = null,
  } = data;

  return (
    <>
      <StudentCourseTotalWidget
        data={data}
        onViewClick={() => setIsModalOpen(true)}
      />
      <FullPageDialog
        open={isModalOpen}
        setOpen={setIsModalOpen}
        title="Course Totals"
        closeButtonTestId="course_total_alert_close_modal_btn"
        disableEscapeKeyDown={disableEscapeKeyDown}
      >
        <StudentCourseTotalContent
          students={courseStudentTotals}
          lowScoringStudentCount={lowScoringStudentCount}
          currentWeekDate={currentWeekDate}
          previousWeekDate={previousWeekDate}
          handleISGLaunch={handleISGLaunch}
          setOpen={setIsModalOpen}
          courseId={courseId}
          apiHost={apiHost}
        />
      </FullPageDialog>
    </>
  );
}

export function StudentCourseTotalContainer(props) {
  return (
    <QueryClientProvider client={queryClient}>
      <DisableEscapeKeyDownProvider>
        <StudentCourseTotal {...props} />
      </DisableEscapeKeyDownProvider>
    </QueryClientProvider>
  );
}
